import * as React from "react";
import { MoneyTextBoxEditor } from "../../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../../../NewBusinessWizard/Components/SharedComponents";

interface IAssumedSippAndBondHoldingsProps extends IProcessComponentProps {}

interface IAssumedSippAndBondHoldingsState {
    selected: boolean;
}

export class AssumedSippAndBondHoldings extends ProcessComponent<
    IAssumedSippAndBondHoldingsProps,
    IAssumedSippAndBondHoldingsState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            selected: true,
        };
    }

    componentDidMount(): void {
        super.componentDidMount();
        if (this.props.data?.Amount > 0) {
            this.setState({ selected: true });
        }
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const { selected } = this.state;

        return (
            <>
                {SectionHeader(
                    "Assumed SIPP/Bond holdings",
                    <>
                        <p>
                            You need to input the overall value of any new single and/or transfer payments in to your
                            client’s SIPP and/or Bond(s) here. The purpose of the assumed SIPP/Bond holding field is to
                            ensure that we are able to calculate your clients Platform Charge accurately on their
                            illustration(s). Platform charges depend on your clients cash holdings and the total value
                            of certain investments that they hold. These are called platform eligible assets (PEAs). For
                            illustration purposes we will assume:{" "}
                        </p>
                        <ul>
                            <li>
                                The value of PEAs from the ISA and/or PP will change in line with what's shown in the
                                rest of the illustration{" "}
                            </li>
                            <li>
                                The value of the PEAs keyed on assumed SIPP/Bond holding won't change but in reality
                                things like growth, charges, payments and withdrawals will affect them{" "}
                            </li>{" "}
                        </ul>
                        <p>
                            You can find more information about which investments are eligible and how the platform
                            charge is calculated in the client terms and conditions or in the adviser user guides{" "}
                            <span>
                                <a className="hyherlink" target="_blank" href="https://www.abrdn.com/platform-adviser">
                                    www.abrdn.com/platform-adviser
                                </a>
                            </span>
                        </p>
                    </>,
                    "is-wide"
                )}
                <RadiosEditor
                    cssWrapper="radio-group rg-150 mb-16"
                    label={"Assumed SIPP/Bond holdings?"}
                    labelGridClasses="sr-only"
                    selected={selected}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => {
                        onChange({ Amount: 0, Currency: CurrencyCode.GBP });
                        this.setState({ selected: v });
                    }}
                    required={"Please select"}
                />
                {selected && (
                    <MoneyTextBoxEditor
                        label={"Cash value"}
                        labelGridClasses="sr-only"
                        cssWrapper="control-size-180"
                        currency={CurrencyCode.GBP}
                        onChange={(v) => onChange({ Amount: v, Currency: CurrencyCode.GBP })}
                        value={data?.Amount}
                        required={"Please enter cash value"}
                        validationRules={[
                            {
                                errorMessage: "value must be > 0",
                                validator: (v) => v > 0,
                            },
                        ]}
                    />
                )}
                <hr />
            </>
        );
    }
}
